import React, { useEffect } from "react";
import Header from "./Header";
import ServicesSection from "./ServicesSection";
import ContactSection from "./ContactSection";
import Footer from "./Footer";

const ServicesPage = () => {
  useEffect(() => {
    // Land at the top of the page when this route opens.
    window.scrollTo({ top: 0, behavior: "instant" });
    const prevTitle = document.title;
    document.title =
      "Aesthetic Services | 'ALOHI Skin & Wellness — Facial, Laser Hair Removal, SkinPen, Genius RF, LaseMD Ultra";
    return () => { document.title = prevTitle; };
  }, []);

  return (
    <div className="services-page" data-testid="services-page">
      <Header />

      <section className="services-hero section-padding" data-testid="services-hero">
        <div className="container">
          <span className="services-hero-eyebrow">Medspa · Oʻahu · Hawaiʻi</span>
          <h1 className="hero-large services-hero-title">Aesthetic Services</h1>
          <p className="services-hero-lede">
            Medical-grade treatments delivered with island warmth. Over a decade of
            expertise in aesthetics — calibrated to every skin tone, every ritual,
            every goal.
          </p>
        </div>
      </section>

      <ServicesSection />
      <ContactSection />
      <Footer />
    </div>
  );
};

export default ServicesPage;
